import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getTicketProjectTasks, getProjects, createProjectTask, errorMessage } from '../services/api';
import { canAction } from '../menu';
import { useLanguage } from '../i18n/LanguageContext';
import Select from './Select';

/**
 * Riquadro nella pagina del ticket: le attività dei Progetti collegate a
 * questo ticket e, per chi può gestire i progetti, la creazione di una nuova
 * attività (già collegata) in uno dei progetti.
 */
function TicketProjectTasks({ ticket, user }) {
  const { t } = useLanguage();
  const canManageProjects = canAction(user, 'projects.manage');
  const [tasks, setTasks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getTicketProjectTasks(ticket.id)
      .then((data) => setTasks(data.tasks || []))
      .catch(() => {});
    if (canManageProjects) {
      getProjects()
        .then((data) => setProjects(data.projects || []))
        .catch(() => {});
    }
  }, [ticket.id, canManageProjects]);

  const createTask = async () => {
    if (!projectId) return;
    setBusy(true);
    setError('');
    try {
      const data = await createProjectTask(Number(projectId), { title: ticket.subject, ticket_id: ticket.id });
      const project = projects.find((p) => p.id === Number(projectId));
      setTasks((prev) => [...prev, {
        task_id: data.task.id,
        title: data.task.title,
        project_id: project.id,
        project_name: project.name,
        project_icon: project.icon,
      }]);
      setProjectId('');
    } catch (err) {
      setError(errorMessage(err, t('tickets.projectTaskError')));
    } finally {
      setBusy(false);
    }
  };

  if (tasks.length === 0 && !canManageProjects) return null;

  return (
    <div className="card ticket-linked-tasks">
      <div className="card-body">
        <label className="sidebar-field-label">{t('tickets.projectTasks')}</label>
        {tasks.length === 0 && <p className="nt-muted">{t('tickets.noProjectTasks')}</p>}
        {tasks.map((task) => (
          <div key={task.task_id} className="pd-link-item">
            <span aria-hidden="true">{task.project_icon || '📋'}</span>
            <Link to={`/projects/${task.project_id}?task=${task.task_id}`} state={{ from: `/tickets/${ticket.id}` }} title={task.project_name}>
              {task.title || t('projectDetail.untitled')}
            </Link>
          </div>
        ))}
        {canManageProjects && projects.length > 0 && (
          <div className="ticket-linked-tasks-create">
            <Select value={projectId} onChange={(e) => setProjectId(e.target.value)} aria-label={t('tickets.projectTaskProject')}>
              <option value="">{t('tickets.projectTaskProject')}</option>
              {projects.map((p) => (
                <option key={p.id} value={p.id}>{p.icon ? `${p.icon} ${p.name}` : p.name}</option>
              ))}
            </Select>
            <button type="button" className="btn btn-secondary" disabled={!projectId || busy} onClick={createTask}>
              {t('tickets.createProjectTask')}
            </button>
          </div>
        )}
        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
}

export default TicketProjectTasks;
